var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManBrokenBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 481 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no-internet-clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nointernet_a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -25,
    width: 481,
    height: 243
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-25h481v243H0z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#nointernet_a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.169 122.859c-29.611-33.397-80.168-88.262-105.447-87.786C141.106 36.16 114.891 126.217 66.5 162c-39.595 29.279 267.708-5.262 237.669-39.141z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.182 108.264c-29.612-33.397-80.169-88.263-105.447-87.786-57.617 1.087-67.169 70.61-115.56 106.393-39.593 29.278 251.046 15.27 221.007-18.607z",
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.396 139.219l-.701-3.765c2.82-.523 23.962-2.595 26.364-2.829l.373 3.811c-11.221 1.097-24.154 2.435-26.036 2.783z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-27 195c102.333-15.5 203-17.68 274.5-43.5C319 125.681 432 101 522 112",
    stroke: "#8F97B9",
    strokeWidth: 66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27 195c102.333-15.5 203-17.68 274.5-43.5C319 125.681 432 101 522 112",
    stroke: "#fff",
    strokeWidth: 6,
    strokeDasharray: "30 30 30 30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.491 20.205c5.123 2.319 9.822 6.521 13.411 3.308 1.419-1.27.335-5.507-.647-8.451-.59-1.766.23-3.31-.768-4.192-3.299-2.917-4.596-1.913-6.479-2.195-.281-.042-.938-1.233-1.225-.972-.193.175.611 1.233-.116 1.094-.992-.191-1.542.059-1.593.098-.864.632 1.796.297 1.006.818-1.442.952-5.489 2.122-6.06 2.912-.603.834.893.594.893.594-1.299.765-5.228 2.436-5.109 4.574.034.61 1.368-.466 1.071-.06a2.847 2.847 0 00-.536 1.96c.595 2.969 3.157-1.4 3.889-.821.698.533 1.458.98 2.263 1.333z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.639 30.67l4.71-6.103-8.452-5.891-1.208 5.303 4.95 6.69z",
    fill: "#FFDFAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.61 25.317c.338.02 2.862.69 3.922-.895.877-1.669-2.053-6.079-3.059-5.958-.422.007-.091 2.597-.503 2.508-.912-.17.687 2.485.894 3.097.207.612-2.095.942-1.254 1.248z",
    fill: "#F4CA92"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.275 17.28c3.599 3.63-.056 8.544-1.319 9.706-1.566 1.441-7.647-2.853-11.195-6.064a6.484 6.484 0 01-1.555-2.062c3.697-1.349 6.492-6.072 6.706-5.762 1.718 2.497 1.711-.135 3.909 1.1.701.394 1.171-2.533 2.995-.11 1.015 1.352-.299 2.428.459 3.193z",
    fill: "#FFDFAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.258 16.131l3.075-3.555.716.623-3.075 3.555-.716-.623z",
    fill: "#BBC0D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.268 26.497c1.015.738 4.64 1.981 6.557-.648 2.674-3.671-.392-8.19-1.407-8.929-.468-.34 1.067 2.834.085 3.599-1.144.891-3.702 2.196-5.002 3.367-2.426 2.188-1.247 1.873-.233 2.611z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.342 23.96c-.201-.213-1.668-.615-2.504.172-.837.788-1.034 1.873-.833 2.088.2.214.826-.163 1.663-.952.838-.788 1.875-1.095 1.674-1.308z",
    fill: "#FFDFAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.725 56.56l-6.936 2.832s-6.72 2.833-2.654 8.823c4.066 5.991 21.487 22.434 21.487 22.434l4.491-2.16s-2.745-15.431-8.137-17.319c-2.695-.943-5.145-3.153-4.864-3.894.287-.755 4.521-.656 4.521-.656l-4.452-9.624-3.456-.436z",
    fill: "#F4CA92"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.53 85.718a28.838 28.838 0 002.499 5.5l4.346-2.184 3.314-1.142-2.144-5.623s-8.45 2.19-8.015 3.449z",
    fill: "#ADADEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.683 91.76c-.169 1.406-4.774 6.474-6.752 9.743-.874 1.443-.562 3.124.238 3.212 1.579.174 9.858-5.093 9.858-5.093l8.485-5.262s-1.031-4.088-2.081-6.584c-.191-.454-1.633 1.297-3.47 1.866-2.717.842-6.132.905-6.278 2.117z",
    fill: "#BBC0D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.471 91.147c-.169 1.407-4.735 6.989-6.541 10.356-.803 1.494-.449 2.495.028 2.6 1.551.341 9.858-5.093 9.858-5.093a12.753 12.753 0 012.81-3.121c2.285-1.779 5.419-3.324 5.31-3.721-.491-1.803-1.359-4.707-2.22-6.074-.709-1.125-4.295 4.003-8.299 3.578-.754-.079-.894 1.042-.946 1.475z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.308 100.945s1.316.442 1.609.004l5.211-7.796c.293-.438-.829-1.315-.829-1.315-.566-.377-6.585 8.795-5.991 9.107z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.356 100.75s.936.197 1.222-.232l5.103-7.632c.287-.428-.439-1.038-.439-1.038-.374-.25-6.291 8.714-5.886 8.902zM278.405 100.472l1.858-1.01-1.858 1.01z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.393 100.449a.572.572 0 01.38-.406c.097 0 .194-.006.291-.02a.424.424 0 00.208-.172c.102-.153.242-.277.405-.362a.942.942 0 01.575-.05l.023.043a.937.937 0 01-.354.455 1.1 1.1 0 01-.524.144.426.426 0 00-.258.079c-.071.055-.111.165-.174.233a.574.574 0 01-.549.099l-.023-.043z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.2 100.806l.184-2.106-.184 2.106z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.176 100.804a.571.571 0 01-.129-.542c.054-.08.102-.165.144-.252a.419.419 0 00-.03-.268 1.108 1.108 0 01-.078-.537.939.939 0 01.277-.505l.047.004c.118.158.183.349.185.546a1.092 1.092 0 01-.17.516.426.426 0 00-.076.259c.027.093.059.184.098.273a.572.572 0 01-.22.512l-.048-.006z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.869 99.848l1.859-1.01-1.859 1.01z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.857 99.826a.571.571 0 01.381-.407c.097 0 .194-.006.29-.02a.424.424 0 00.209-.172c.102-.153.241-.278.405-.362a.938.938 0 01.575-.05l.023.043a.936.936 0 01-.354.456c-.16.09-.34.14-.524.143a.426.426 0 00-.258.079c-.07.055-.111.165-.174.233a.574.574 0 01-.549.098l-.024-.041z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.665 100.182l.183-2.106-.183 2.106z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.641 100.18a.57.57 0 01-.129-.541c.053-.081.102-.165.144-.253a.418.418 0 00-.03-.267 1.096 1.096 0 01-.077-.537.93.93 0 01.276-.506l.048.004c.117.158.182.35.184.547-.012.183-.07.36-.169.516a.419.419 0 00-.076.258c.026.094.059.185.098.274a.574.574 0 01-.221.512l-.048-.007z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.481 98.984l1.902-1.042-1.902 1.042z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.47 98.962a.593.593 0 01.391-.414c.099-.001.199-.01.297-.024a.446.446 0 00.212-.178c.106-.156.249-.283.416-.37.185-.08.39-.1.587-.057l.023.042a.971.971 0 01-.364.463 1.143 1.143 0 01-.535.152.439.439 0 00-.263.083c-.073.056-.115.167-.179.238a.594.594 0 01-.559.106l-.026-.041z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.3 99.34l.174-2.2-.174 2.2z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.276 99.337a.611.611 0 01-.131-.565 2.4 2.4 0 00.143-.265.454.454 0 00-.032-.279 1.177 1.177 0 01-.08-.56c.035-.2.131-.386.274-.53l.048.003a.998.998 0 01.187.568c-.011.19-.069.376-.167.54a.464.464 0 00-.076.27c.027.097.061.192.1.285a.615.615 0 01-.218.535l-.048-.002z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.87 98.09L281.915 97l-2.045 1.092z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.858 98.069a.665.665 0 01.429-.428c.104-.003.209-.013.313-.03a.497.497 0 00.23-.183c.12-.16.275-.292.453-.382.196-.084.411-.108.62-.07l.023.043a1.078 1.078 0 01-.402.477 1.3 1.3 0 01-.57.163.5.5 0 00-.281.09c-.079.059-.127.172-.198.243a.668.668 0 01-.595.119l-.022-.042z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.734 98.432l.233-2.22-.233 2.22z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.709 98.43a.624.624 0 01-.116-.574 2.25 2.25 0 00.15-.265.465.465 0 00-.023-.283 1.206 1.206 0 01-.066-.568c.04-.202.141-.387.289-.53l.047.005c.115.17.175.373.172.578a1.217 1.217 0 01-.182.542.472.472 0 00-.083.272c.025.1.055.196.092.29a.622.622 0 01-.233.536l-.047-.004z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.455 97.242l2.109-1.085-2.109 1.085z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.443 97.22a.694.694 0 01.447-.427c.106-.003.213-.012.319-.028a.525.525 0 00.239-.183c.126-.161.287-.292.47-.382.201-.083.421-.106.634-.066l.022.043a1.122 1.122 0 01-.421.477c-.18.097-.38.152-.585.16a.525.525 0 00-.288.09c-.081.06-.133.172-.208.244a.694.694 0 01-.608.115l-.021-.043z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.339 97.668l.258-2.435-.258 2.435z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.315 97.666a.727.727 0 01-.11-.627c.057-.094.108-.192.153-.292a.555.555 0 00-.021-.31 1.425 1.425 0 01-.059-.622c.04-.219.142-.422.294-.584l.047.004c.114.191.172.41.166.633-.018.21-.082.413-.188.595a.554.554 0 00-.085.299c.023.107.053.213.089.317a.732.732 0 01-.238.59l-.048-.003z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.108 96.217l2.11-1.086-2.11 1.086z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.098 96.194a.691.691 0 01.446-.427 2.44 2.44 0 00.319-.027.518.518 0 00.238-.184c.126-.161.287-.291.471-.382.2-.083.42-.105.633-.066l.022.043a1.115 1.115 0 01-.421.477c-.18.097-.38.152-.585.161a.527.527 0 00-.288.09c-.081.059-.133.172-.208.243a.692.692 0 01-.608.116l-.019-.044z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.992 96.643l.24-2.263-.24 2.263z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.969 96.64a.647.647 0 01-.115-.584c.056-.086.107-.177.151-.27a.483.483 0 00-.023-.288 1.266 1.266 0 01-.064-.579c.041-.205.142-.394.29-.541l.048.005c.115.175.174.38.17.59a1.249 1.249 0 01-.183.552.473.473 0 00-.083.277c.024.1.054.2.091.296a.644.644 0 01-.235.547l-.047-.004z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.692 95.41l2.147-1.325-2.147 1.324z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.679 95.387a.767.767 0 01.445-.48c.112-.014.223-.035.332-.062a.59.59 0 00.24-.211c.124-.178.285-.327.472-.437.203-.105.43-.15.658-.134l.025.04c-.087.212-.23.394-.415.529a1.516 1.516 0 01-.602.225.587.587 0 00-.297.119 2.75 2.75 0 00-.205.267.768.768 0 01-.629.183l-.024-.039z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.646 95.72l.202-2.257-.202 2.257z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.621 95.717a.645.645 0 01-.124-.58 2.33 2.33 0 00.147-.271.479.479 0 00-.03-.287 1.253 1.253 0 01-.073-.576 1.04 1.04 0 01.281-.543l.048.004c.117.172.18.376.18.585a1.235 1.235 0 01-.174.553.478.478 0 00-.079.277c.026.1.058.198.096.293a.642.642 0 01-.225.55l-.047-.005z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.231 94.38l2.262-1.212-2.262 1.213z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.22 94.36a.79.79 0 01.483-.458c.114-.008.228-.023.34-.045a.616.616 0 00.258-.198c.137-.172.31-.312.505-.413.212-.094.445-.128.675-.099l.023.043a1.275 1.275 0 01-.456.507 1.568 1.568 0 01-.624.193.605.605 0 00-.308.104 2.749 2.749 0 00-.226.26.791.791 0 01-.648.148l-.022-.043z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.449 94.803l.154-2.337-.154 2.337z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.424 94.8a.676.676 0 01-.136-.594 2.5 2.5 0 00.141-.284.508.508 0 00-.035-.296 1.332 1.332 0 01-.085-.593c.032-.211.126-.409.269-.568l.048.003c.121.176.188.385.192.6a1.31 1.31 0 01-.162.576.514.514 0 00-.073.288c.028.102.062.202.103.3a.679.679 0 01-.214.573l-.048-.004z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.606 49.446l-17.88 7.114 5.335 10.112s6.311.067 8.005-.974c2.544-1.565 6.336-9.827 6.336-9.827l-1.796-6.425z",
    fill: "#2D4177"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.282 30.828s-2.918 8-3.15 9.766c-.22 1.678.628 4.66.628 4.66s-6.656-.575-9.624 1.557c-2.269 1.63-11.188.715-11.188.715s-1.534-2.666-3.202-1.596c-1.669 1.07-2.302.264-3.342 1.968-.709 1.162 2.129 3.427 4.459 4.257 3.267 1.164 13.715-.345 13.715-.345s8.313-.38 10.605-1.445c2.292-1.066 3.314 1.75 3.751-1.704.437-3.454 3.21-14.67 3.21-14.67l-5.862-3.163z",
    fill: "#F4CA92"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.768 43.8l-7.638-1.856c-.572-.25 1.24-10.76 1.24-10.76a1.06 1.06 0 011.271-.783l8.249 2.322c.552.183.853.777.675 1.33l-2.526 8.963a1.061 1.061 0 01-1.271.784z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.355 174.666c13.848 0 25.074-11.219 25.074-25.059 0-13.84-11.226-25.06-25.074-25.06s-25.074 11.22-25.074 25.06c0 13.84 11.226 25.059 25.074 25.059z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.379 179.036c1.665.282 3.351.424 5.04.424 15.832-.039 28.882-12.42 29.742-28.219.86-15.8-10.769-29.523-26.503-31.278-15.734-1.754-30.103 9.07-32.749 24.67a29.83 29.83 0 005.106 22.266 29.864 29.864 0 0019.364 12.137zm-15.024-32.807c1.649-9.738 10.076-16.873 19.957-16.899 1.147 0 2.292.097 3.422.289a20.268 20.268 0 018.374 36.511 20.294 20.294 0 01-22.529.652 20.269 20.269 0 01-9.224-20.553z",
    fill: "#56557E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.544 159.062a27.487 27.487 0 0025.826 18.018c13.4-.029 24.835-9.693 27.087-22.895a27.466 27.466 0 00-13.491-28.444 27.501 27.501 0 00-31.363 2.891 27.462 27.462 0 00-8.059 30.43zm7.902-10.199c.403-9.588 8.298-17.153 17.9-17.153 1.003 0 2.004.084 2.994.251 9.466 1.604 15.985 10.382 14.779 19.902-1.206 9.52-9.708 16.397-19.276 15.593-9.568-.805-16.8-9.005-16.397-18.593z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.982 143.078a29.918 29.918 0 0023.061 10.844c15.74-.039 28.747-12.284 29.725-27.985.978-15.7-10.408-29.463-26.021-31.453-15.614-1.99-30.092 8.476-33.088 23.92a29.88 29.88 0 006.323 24.674zm15.34-.24c-8.96-3.652-14.092-13.122-12.255-22.618a20.294 20.294 0 018.554-12.947c8.017-5.417 18.747-4.42 25.627 2.381a20.265 20.265 0 012.662 25.584c-5.333 8.071-15.627 11.253-24.588 7.6z",
    fill: "#56557E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.982 146.749c12.535 0 22.696-10.155 22.696-22.683 0-12.527-10.161-22.683-22.696-22.683-12.535 0-22.696 10.156-22.696 22.683 0 12.528 10.161 22.683 22.696 22.683z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.814 141.563a27.53 27.53 0 0021.225 9.98c14.488-.035 26.459-11.306 27.359-25.757.901-14.45-9.579-27.118-23.95-28.95-14.371-1.83-27.696 7.803-30.453 22.017a27.499 27.499 0 005.819 22.71zm17.771.073c-9.71-1.875-16.061-11.262-14.184-20.966 1.886-9.698 11.271-16.039 20.978-14.176 9.71 1.875 16.06 11.262 14.184 20.966-1.876 9.704-11.268 16.051-20.978 14.176z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.81 63.413l42.582 12.028a1.26 1.26 0 01.878 1.549l-.539 1.918a1.255 1.255 0 01-1.554.862l-42.582-12.028a1.26 1.26 0 01-.878-1.549l.539-1.918a1.255 1.255 0 011.554-.862zM244.032 69.908l27.986 41.499a1.258 1.258 0 01-.321 1.744l-1.634 1.108a1.248 1.248 0 01-1.733-.35l-27.986-41.5a1.256 1.256 0 01.321-1.743l1.634-1.108a1.248 1.248 0 011.733.35z",
    fill: "#D8984D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.791 113.734a.696.696 0 01.816-.552l36.662 7.105a.697.697 0 01.551.815l-.315 1.633a.696.696 0 01-.816.552l-36.662-7.105a.694.694 0 01-.55-.814l.314-1.634zM221.02 104.225l25.466-46.557c.773-1.379 3.015-2.287 3.53-1.84 1.169.367 1.495 1.795.723 3.173L224.92 106.08c-.918 1.73-2.007 1.684-3.177 1.317-1.169-.366-1.494-1.794-.723-3.172z",
    fill: "#F9B25F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.194 49.236l9.574 6.992c.563.41.689 1.2.281 1.762l-1.176 1.62a1.25 1.25 0 01-.821.502 1.262 1.262 0 01-.938-.229l-9.574-6.99a1.265 1.265 0 01-.281-1.764l1.176-1.62a1.256 1.256 0 011.759-.273zM286.322 75.895l22.469 45.628a.907.907 0 01-.398 1.217l-1.096.543a.901.901 0 01-1.205-.423l-22.47-45.628a.908.908 0 01.398-1.218l1.096-.543a.903.903 0 011.206.424z",
    fill: "#F9B25F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.192 109.129l29.402-53.514c.869-1.581 2.546-2.594 3.726-2.249 1.179.345 1.434 1.92.565 3.502l-29.401 53.513c-.869 1.582-2.546 2.594-3.726 2.25-1.18-.345-1.435-1.921-.566-3.502z",
    fill: "#D8984D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.522 49.435c-.43 2.421-1.863 4.192-3.199 3.954-1.336-.238-2.188-.737-1.757-3.16.43-2.421 1.978-5.846 3.315-5.61 1.336.237 2.07 2.394 1.641 4.816z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.183 121.62a7.624 7.624 0 007.626-7.622 7.624 7.624 0 00-7.626-7.622 7.624 7.624 0 00-7.626 7.622 7.624 7.624 0 007.626 7.622z",
    fill: "#F9B25F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.914 106.864a1.444 1.444 0 100-2.888 1.444 1.444 0 000 2.888z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.592 125.374l8.221.19a.547.547 0 01.535.559l-.02.87a.548.548 0 01-.56.535l-8.221-.19a.547.547 0 01-.535-.559l.02-.871a.547.547 0 01.56-.534z",
    fill: "#D8984D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.01 127.11a.909.909 0 100-1.818.909.909 0 000 1.818z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.695 104.031a.416.416 0 01.208-.548l7.734-3.487a.415.415 0 01.549.208l.46 1.027a.415.415 0 01-.208.547l-7.734 3.487a.415.415 0 01-.549-.208l-.46-1.026z",
    fill: "#D8984D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.585 103.579a.768.768 0 100-1.536.768.768 0 000 1.536zM306.162 122.445a1.444 1.444 0 100-2.888 1.444 1.444 0 000 2.888z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.703 84.875l4.732-7.902c.334-.557 1.182-.684 1.924-.339.106.05 2.693 1.222 2.693 1.222.658.454.593 1.562.278 2.086l-4.585 7.632c-.253.37-.689.574-1.136.53a4.755 4.755 0 01-2.524-.803 6.942 6.942 0 01-1.128-1.022 1.184 1.184 0 01-.254-1.404z",
    fill: "#8F97B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.322 83.58l5.329 2.304a.36.36 0 01.189.47l-.225.523a.358.358 0 01-.471.186l-5.329-2.304a.36.36 0 01-.189-.47l.225-.523a.358.358 0 01.471-.186zM232.331 82.059l5.33 2.304c.182.078.266.289.188.47l-.224.523a.358.358 0 01-.471.185l-5.329-2.304a.36.36 0 01-.189-.47l.225-.523a.356.356 0 01.47-.185zM233.384 80.322l5.329 2.304c.183.078.267.29.189.47l-.224.523a.358.358 0 01-.471.185l-5.329-2.304a.36.36 0 01-.189-.47l.224-.523a.358.358 0 01.471-.185zM234.388 78.755l5.329 2.304a.36.36 0 01.189.471l-.225.522a.358.358 0 01-.471.186l-5.329-2.304a.36.36 0 01-.189-.47l.225-.523a.358.358 0 01.471-.186zM235.302 77.09l5.329 2.304a.36.36 0 01.189.471l-.225.523a.358.358 0 01-.471.185l-5.329-2.304a.36.36 0 01-.189-.47l.225-.523a.358.358 0 01.471-.186z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.235 66.844l-3.989 5.83s-2.443 2.388-1.64 8.484c.802 6.096-2.269 35.646-2.269 35.646l4.792.265 3.396.656 2.125-12.131s4.918-12.912 3.609-18.665c-.998-4.383-1.24-4.606.169-6.568 1.138-1.585 5.345-6.009 5.345-6.009l-11.538-7.508z",
    fill: "#FFDFAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.777 111.469a28.748 28.748 0 00-.584 6.011l4.856.278 3.442.665.952-5.942s-8.413-2.32-8.666-1.012z",
    fill: "#3B58A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.757 117.279c-.85 1.135-7.372 3.226-10.72 5.071-1.478.815-2.048 2.426-1.398 2.902 1.281.939 11.086.509 11.086.509l9.979-.323s1.151-4.056 1.488-6.743c.062-.489-2.063.309-3.939-.116-2.775-.627-5.764-2.278-6.496-1.3z",
    fill: "#BBC0D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.879 116.642c-.85 1.135-7.594 3.692-10.842 5.708-1.441.894-1.636 1.937-1.275 2.266 1.173 1.071 11.086.509 11.086.509a12.733 12.733 0 013.994-1.302c2.869-.4 6.355-.175 6.46-.573.476-1.807 1.174-4.757 1.111-6.37-.052-1.329-5.721 1.323-8.978-1.043-.613-.445-1.294.457-1.556.805z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.643 122.055s.92 1.04 1.392.806l8.411-4.152c.473-.233-.062-1.553-.062-1.553-.301-.609-10.1 4.333-9.741 4.899z",
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.785 121.91s.712.638 1.175.409l8.234-4.065c.463-.228.138-1.118.138-1.118-.2-.403-9.806 4.408-9.547 4.774z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.964 121.693l2.115.052-2.115-.052z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.965 121.668a.574.574 0 01.533-.163c.083.049.171.092.261.129a.424.424 0 00.266-.047c.165-.081.348-.119.531-.111.196.024.379.11.523.244v.048a.935.935 0 01-.535.218 1.1 1.1 0 01-.526-.137.419.419 0 00-.263-.059c-.092.032-.181.07-.268.114a.572.572 0 01-.524-.188l.002-.048z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.485 122.38l1.212-1.733-1.212 1.733z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.465 122.366a.572.572 0 01.16-.535c.087-.043.171-.092.251-.147a.423.423 0 00.107-.247c.024-.183.093-.357.201-.506a.942.942 0 01.493-.3l.039.027a.934.934 0 01-.113.565 1.086 1.086 0 01-.405.362.421.421 0 00-.194.186c-.024.094-.042.19-.052.286a.571.571 0 01-.446.333l-.041-.024z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.678 121.384l2.115.052-2.115-.052z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.679 121.359a.574.574 0 01.533-.163c.084.049.171.092.261.129a.424.424 0 00.266-.047c.165-.081.348-.119.532-.111.195.024.378.11.523.244v.048a.93.93 0 01-.536.218 1.1 1.1 0 01-.526-.137.419.419 0 00-.263-.059c-.091.032-.181.07-.267.115a.573.573 0 01-.525-.189l.002-.048z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.2 122.071l1.211-1.733-1.211 1.733z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.18 122.058a.571.571 0 01.159-.535c.087-.043.171-.092.251-.147a.426.426 0 00.108-.247c.023-.183.092-.357.201-.506a.936.936 0 01.492-.3l.039.027a.934.934 0 01-.113.565 1.086 1.086 0 01-.405.362.416.416 0 00-.194.186c-.025.094-.042.19-.052.286a.571.571 0 01-.446.333l-.04-.024z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.64 120.941l2.168.047-2.168-.047z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.641 120.916a.594.594 0 01.545-.163c.086.048.176.091.268.127a.443.443 0 00.272-.047 1.14 1.14 0 01.545-.113.971.971 0 01.536.243v.048a.964.964 0 01-.547.219c-.188 0-.373-.047-.539-.135a.437.437 0 00-.269-.06 2.267 2.267 0 00-.274.115.594.594 0 01-.538-.186l.001-.048z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.172 121.658l1.249-1.818-1.249 1.818z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.152 121.644a.614.614 0 01.168-.554c.089-.047.175-.1.257-.158a.464.464 0 00.112-.257c.026-.19.098-.37.209-.525.131-.157.307-.27.503-.324l.04.027c.02.203-.022.407-.121.586-.106.16-.248.291-.415.384a.453.453 0 00-.2.197 2.13 2.13 0 00-.056.297.614.614 0 01-.457.355l-.04-.028z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.423 120.362l2.318.075-2.318-.075z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.423 120.337a.667.667 0 01.585-.157c.092.05.188.094.286.131a.503.503 0 00.291-.044c.184-.08.383-.116.583-.105.212.025.411.112.572.25v.048c-.17.127-.374.201-.586.212a1.281 1.281 0 01-.576-.143.508.508 0 00-.288-.063c-.1.031-.199.069-.294.112a.67.67 0 01-.574-.193l.001-.048z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264 121.087l1.311-1.806-1.311 1.806z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.981 121.073a.623.623 0 01.186-.554c.091-.046.178-.097.262-.155a.47.47 0 00.121-.257c.033-.19.11-.37.227-.525.136-.154.315-.264.515-.315l.039.03c.014.205-.035.41-.141.587-.11.159-.257.288-.428.378a.467.467 0 00-.208.195 2.158 2.158 0 00-.066.297.623.623 0 01-.469.348l-.038-.029z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.354 119.918l2.37.113-2.37-.113z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.355 119.894a.689.689 0 01.601-.147c.094.051.191.096.291.135.1.017.204.003.297-.039.19-.077.394-.11.599-.096.215.028.417.118.581.259l-.002.048a1.118 1.118 0 01-.604.203 1.347 1.347 0 01-.586-.153.53.53 0 00-.294-.066 2.46 2.46 0 00-.302.107.69.69 0 01-.584-.203l.003-.048z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.908 120.73l1.44-1.981-1.44 1.981z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.887 120.715a.732.732 0 01.218-.599c.097-.053.19-.111.279-.176a.555.555 0 00.136-.279c.044-.206.133-.4.26-.568a1.18 1.18 0 01.547-.361l.039.029c.003.222-.057.441-.173.631a1.432 1.432 0 01-.461.422.572.572 0 00-.223.216 2.71 2.71 0 00-.081.319.731.731 0 01-.502.392l-.039-.026z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.432 119.356l2.37.112-2.37-.112z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.434 119.332a.687.687 0 01.6-.147c.094.051.191.096.29.135a.52.52 0 00.299-.039c.19-.077.395-.11.599-.096.215.028.417.118.582.259l-.003.048a1.117 1.117 0 01-.603.203 1.36 1.36 0 01-.587-.152.528.528 0 00-.294-.068c-.103.03-.204.066-.302.108a.691.691 0 01-.584-.204l.003-.047z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.985 120.167l1.339-1.841-1.339 1.841z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.966 120.152a.643.643 0 01.192-.563c.092-.047.181-.1.266-.158a.489.489 0 00.124-.262c.035-.194.115-.376.234-.533.138-.158.319-.271.522-.324l.038.028a1.04 1.04 0 01-.147.596 1.238 1.238 0 01-.434.386.489.489 0 00-.211.199c-.03.099-.053.2-.069.301a.643.643 0 01-.476.357l-.039-.027z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.343 118.948l2.522-.076-2.522.076z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.342 118.923a.773.773 0 01.625-.194c.103.044.21.081.318.112a.588.588 0 00.314-.062 1.51 1.51 0 01.626-.144c.228.011.449.084.638.212v.048a1.23 1.23 0 01-.625.25 1.51 1.51 0 01-.634-.105.604.604 0 00-.317-.044c-.106.038-.21.081-.312.131a.77.77 0 01-.635-.156l.002-.048z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.012 119.693l1.303-1.855-1.303 1.855z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.993 119.679a.638.638 0 01.182-.565 2.28 2.28 0 00.262-.162.475.475 0 00.119-.262c.031-.193.108-.377.224-.535.135-.159.314-.274.515-.331l.039.028c.016.208-.032.416-.136.596-.11.163-.256.297-.427.393a.483.483 0 00-.209.201 2.57 2.57 0 00-.063.302.641.641 0 01-.469.363l-.037-.028z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.323 118.326l2.565.079-2.565-.079z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.325 118.302a.793.793 0 01.646-.156c.103.051.209.094.317.131.11.016.221.001.323-.043a1.56 1.56 0 01.645-.105c.23.025.449.111.634.251v.048a1.264 1.264 0 01-.648.212 1.58 1.58 0 01-.638-.144.597.597 0 00-.319-.063c-.11.03-.218.068-.324.112a.795.795 0 01-.636-.195v-.048z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.166 119.299l1.301-1.947-1.301 1.947z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.146 119.286a.679.679 0 01.179-.585c.091-.052.179-.111.263-.175a.51.51 0 00.119-.274c.031-.2.107-.39.222-.556.134-.167.314-.292.518-.358l.04.026c.017.214-.029.428-.133.616-.108.17-.255.313-.428.418a.51.51 0 00-.208.214 2.344 2.344 0 00-.062.311.676.676 0 01-.471.389l-.039-.026z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.761 46.273c2.793-.781 11.048-2.487 11.048-2.487s2.332 2.389 2.83 3.37c1.208 2.374 1.645 7.87-2.563 12.559-4.209 4.688-19.924 18.559-19.924 18.559l-10.059-8.324s15.876-22.897 18.668-23.677z",
    fill: "#3B58A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.602 38.194s-1.204 3.948-1.107 5.727a5.879 5.879 0 01-.574 2.97s-6.574-1.49-9.701 1.207c-1.279 1.102-12.522-.078-12.522-.078s-1.49-2.354-3.393-1.621c-1.902.733-1.674.016-2.247 1.677-.446 1.291.589 2.63 2.926 3.68 2.509 1.127 13.292 1.538 13.292 1.538s9.654.914 12.162.186c4.176-1.212 4.281-1.13 5.496-3.058 2.905-4.608 4.37-10.547 4.37-10.547l-8.702-1.68z",
    fill: "#FFDFAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.241 21.843s10.443-1.887 14.746-1.113c4.898.881 9.9 3.452 14.884 7.274 7.211 5.53 10.109 16.034 10.109 16.034s-1.3.353-5.068 2.123c-3.788 1.78-8.77 2.455-10.236 4.162-.682.793-.325-3.934-4.78-3.833a26.833 26.833 0 01-11.916-2.44l1.323-4.176s-8.023-1.77-8.742-1.468c-.719.302-2.597-8.202-2.597-8.202l2.277-8.361z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.383 42.916l-8.436-1.629c-.712-.137-.07-6.398.881-7.683.794-1.073 9.434-3.336 10.398 1.599.398 2.036-2.131 7.85-2.843 7.713z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.316 16.785c-1.153-1.08-2.746-1.254-3.559-.386-.537.572-.591 1.452-.238 2.297l-.969.912c-.959-.478-1.976-.447-2.547.162-.763.813-.446 2.349.705 3.429 1.151 1.08 2.707 1.296 3.468.484.762-.813.446-2.349-.705-3.429a3.975 3.975 0 00-.492-.392l.765-.721c.173.288.384.551.628.782 1.153 1.08 2.746 1.254 3.559.386.813-.867.537-2.444-.615-3.524z",
    fill: "#FF6369"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no-internet-clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h481v171H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBrokenBike);
export default __webpack_public_path__ + "static/media/man-broken-bike.3b474cffe7bbc1bafd214d25f6a378c2.svg";
export { ForwardRef as ReactComponent };